module.exports = __webpack_public_path__ + "img/dental-background.5945175a.svg";